/**
 * Cliente del módulo «Uso de la app» (solo admin). Envuelve `portal_usoAppEstadisticas`,
 * que lee los contadores diarios que reporta la app móvil y los datos que ya existen
 * (cuentas en Firebase Auth, teleconsultas, registros biométricos) del MISMO ambiente.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export type PorPlataforma = { ios?: number; android?: number };

export interface DiaUsoApp {
  fecha: string;
  /** tipo de evento → por plataforma */
  eventos: Record<string, PorPlataforma>;
  activos: PorPlataforma & { total?: number };
  teleconsultas: number | null;
  cuentasNuevas: number;
  kyc: { total: number; aprobadas: number } | null;
  consolidado: boolean;
}

export interface ActivosPeriodo { periodo: string; desde?: string; ios?: number; android?: number; total: number }

export interface EstadisticasUsoApp {
  desde: string;
  hasta: string;
  serie: DiaUsoApp[];
  topPantallas: { nombre: string; ios: number; android: number }[];
  activosSemana: ActivosPeriodo[];
  activosMes: ActivosPeriodo[];
  auth: { d1: number; d7: number; d30: number; pacientes: number; calculadoEn: string } | null;
  /** Primer día con datos reportados por la app; null si ninguna versión instalada los manda aún. */
  recoleccionDesde: string | null;
  /** tipo de evento → descripción legible */
  eventos: Record<string, string>;
  actualizadoEn: string;
}

export async function obtenerEstadisticasUsoApp(filtros: { desde?: string; hasta?: string }): Promise<EstadisticasUsoApp> {
  const fn = httpsCallable<typeof filtros, EstadisticasUsoApp>(functions, 'portal_usoAppEstadisticas');
  return (await fn(filtros)).data;
}
